<template>
  <header class="header">
    <div class="header__wrapper">
      <a
        :href="defaultPathToUse"
        class="header__left"
        @click="event => clickHeader(defaultPathToUse, event)"
      >
        <SvgImage
          height="40"
          width="40"
          value="logo"
          class="header__left-logo"
        />
        <div class="header__left-text">Электронная похозяйственная книга</div>
      </a>
      <div v-if="$route.fullPath !== '/login'" class="header__right">
        <ModalFiles class="header__right-button" />
        <div class="header__right-card">
          <h6 class="header__right-role">Роль: {{ roleName }}</h6>
          <div class="header__right-name">
            <Icon
              v-if="isLeader"
              prefix="mks-icons"
              value="rating-rating-fill"
              :ui="{ icon: 'header__right-icon' }"
            />
            <h4>{{ name }}</h4>
          </div>
          <div class="header__right-text">
            {{ orgName }}
          </div>
        </div>
        <div
          ref="target"
          class="header__right-full-name"
          @click="toggleProfileMenu"
        >
          {{ symbols }}
          <div v-if="profileMenuVisibility" tabindex="0" class="header__menu">
            <div class="header__menu-item" @click="logout">Выход</div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { KeycloakAdapter } from 'keycloak-js';
import { computed, inject, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useRoleName } from '~packages/epk-front-shared';
import { Icon, ModalFiles, SvgImage } from '~packages/epk-front-shared/ui';
import { useOrg } from '~packages/epk-org-client';

import getConstants from '@/constants';
import removeCharFromEnd from '@/helpers/removeCharFromEnd';
import { defaultPath } from '@/router/routes';
import { useOrgStore } from '@/shared/model';
import { useModalNotification } from '@/store';
import { onClickOutside } from '@vueuse/core';

const modalNotification = useModalNotification();
const { logoutSessionStorageKey, routerBasePath } = getConstants();
const { isLeader } = useOrg();
const { roleName } = useRoleName();

const router = useRouter();

const target = ref(null);

const defaultPathToUse = routerBasePath
  ? `${removeCharFromEnd(routerBasePath, '/')}${defaultPath}`
  : defaultPath;

/* Keycloak */
const keycloak = inject('keycloak') as KeycloakAdapter;

// eslint-disable-next-line @typescript-eslint/no-explicit-any

const orgStore = useOrgStore();

const profileMenuVisibility = ref(false);

const name = computed(() => orgStore.userInfo.user_fio);
const symbols = computed(
  () =>
    name.value
      .split(' ')
      .map((word: string) => word[0])
      .join('') || ''
);
const orgName = computed(() => orgStore.userInfo.org_choose?.name);

const toggleProfileMenu = () => {
  profileMenuVisibility.value = !profileMenuVisibility.value;
};

const logout = () => {
  localStorage.clear();
  keycloak.logout();
  sessionStorage.setItem(logoutSessionStorageKey, 'true');
};

//TODO лучше сделать модалку изменений на глобольном уровне
const clickHeader = (item: any, event: any) => {
  event.preventDefault();

  modalNotification.checkChanges();
  if (modalNotification.isModalActive) return;
  router.push(item);
};

const init = () => {
  orgStore.init();
};

const onTargetClickOutside = () => {
  if (profileMenuVisibility.value) {
    profileMenuVisibility.value = false;
  }
};

onClickOutside(target, onTargetClickOutside);

init();
</script>

<style lang="scss">
@import './EpkHeader';
</style>
